import { isExamDurationId } from '../../utils/examSubscriptionIds';
import { getStoredUser } from '../../utils/authStorage';

const storageKey = (kind) => {
  const user = getStoredUser() || {};
  return `examSubscription:${kind}:${user.id || user.user_id || user.userId || 'current'}`;
};
const id = value => Number.isInteger(Number(value)) && Number(value) > 0 ? Number(value) : 0;

export function normalizeExamDraft(value) {
  const unresolvedDuration = value?.durationId === null;
  if (!id(value?.planId) || (!unresolvedDuration && !isExamDurationId(value?.durationId))) return null;
  return { planId: id(value.planId), durationId: unresolvedDuration ? null : Number(value.durationId), stateId: id(value.stateId) };
}
function read(kind) {
  try { return JSON.parse(sessionStorage.getItem(storageKey(kind)) || 'null'); }
  catch { return null; }
}
function save(kind, value) {
  try { sessionStorage.setItem(storageKey(kind), JSON.stringify(value)); }
  catch { /* Route state remains usable when storage is unavailable. */ }
}
export const readExamDraft = () => normalizeExamDraft(read('draft'));
export const readExamState = () => { const value = read('state'); return value == null ? null : id(value); };
export const saveExamState = value => save('state', id(value));
export function saveExamDraft(value) {
  const draft = normalizeExamDraft(value);
  if (draft) save('draft', draft);
}
export function readExamCheckout() {
  const value = read('checkout');
  return value?.examSubscriptionOrder?.vk_order_id && value?.examPurchase?.kind === 'exam_plan' ? value : null;
}
export function saveExamCheckout(value) {
  if (!value?.examSubscriptionOrder?.vk_order_id || value?.examPurchase?.kind !== 'exam_plan') return;
  // Persist identifiers and prices, never gateway credentials or customer contacts.
  const { vk_order_id, plan_id, product_type, plan_name, subscription_price } = value.examSubscriptionOrder;
  const paymentGateway = value.paymentGateway ? Object.fromEntries(['payment_gateway_id', 'slug', 'gateway', 'description', 'gateway_img_url', 'share_description'].map(key => [key, value.paymentGateway[key]])) : undefined;
  save('checkout', { examPurchase: value.examPurchase, examSubscriptionOrder: { vk_order_id, plan_id, product_type, plan_name, subscription_price }, ...(paymentGateway ? { paymentGateway } : {}) });
}
export function clearExamCheckout() {
  try { sessionStorage.removeItem(storageKey('checkout')); } catch { /* Optional storage. */ }
}
export const readExamCoupon = () => String(read('coupon') || '').trim();
export const saveExamCoupon = code => save('coupon', String(code || '').trim());
